// Check if global scope is available
window.RosenheimJetzt = window.RosenheimJetzt ? window.RosenheimJetzt : []

/**
 * Controls the behaviour of the mobile menu
 * @type {Window.RosenheimJetzt.MobileMenu}
 */
window.RosenheimJetzt.MobileMenu = class MobileMenu {
	constructor() {
		//get navigator elemetns
		const mobileMenuButtonClass = '.js-mobile-menu'
		this.mobileMenuButton = document.querySelector(mobileMenuButtonClass)

		//get navigator elemetns
		const subMenuNavigatiorClass = '.js-sub-menu__navigator'
		this.navigatorElements = document.querySelectorAll(subMenuNavigatiorClass)

		//used css class to add or remove
		this.selectedClass = 'sub-menu--selected'
		this.closedClass = 'sub-menu--closed'

		// add events
		this.addEvents()
	}

	addEvents() {
		this.navigatorElements.forEach((element) =>
			element.addEventListener('click', () => this.handleNavigation(element))
		)
		this.mobileMenuButton.addEventListener('click', () => this.openMobileMenuAndResetMenu())
	}

	handleNavigation(element) {
		//opener
		let menuRelationElement = document.querySelector(
			'[data-sub-menu-identifier="' + element.dataset.subMenuRelation + '"]'
		)

		if (element.dataset.subMenuOpener && !menuRelationElement.classList.contains(this.selectedClass)) {
			menuRelationElement.classList.remove(this.closedClass)
			menuRelationElement.classList.add(this.selectedClass)
		} else {
			menuRelationElement.classList.remove(this.selectedClass)
			menuRelationElement.classList.add(this.closedClass)
		}
	}

	openMobileMenuAndResetMenu() {
		document.body.classList.toggle('nav-is-visible')
		document
			.querySelectorAll('[data-sub-menu-identifier]')
			.forEach((element) => () => element.classList.remove(this.selectedClass, this.closedClass))
	}
}
